import AddIcon from "../../images/add";

type Props = {
  onClick: (action: string) => void;
  isAbsolute?: boolean;
};

export default function AddButton({ onClick, isAbsolute = true }: Props) {
  return (
    <button
      className={
        "m-2 flex justify-center w-fit " +
        (isAbsolute ? " absolute right-1/2 bottom-16" : " ")
      }
      onClick={() => onClick("add")}
    >
      <AddIcon className="-translate-x-1/2 " />
    </button>
  );
}
